import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  NavbarItem,
  Select,
  Checkbox,
  SelectItem,
} from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useSelectBranch } from '@/hooks/useSelectBranch';
import { useAuthContext } from '@/hooks/useAuthContext';
import { Roles } from '@PorkyCol/utils';
import { JSX } from 'react/jsx-runtime';
import { useLocalStorage } from '@hooks/useLocalStorage';
import { useBranches } from '../../../components/branchSelector/useBranches';
import { TypeCreateOrder } from './type-create-order';

type Props = {
  isNav?: boolean;
};

export const Settings = ({ isNav }: Props) => {
  const [flagSocketCommander, setFlagSocketCommander] = useLocalStorage<boolean>({
    key: 'socket-commander',
    defaultValue: false,
  });
  const [flagSocketTicket, setFlagSocketTicket] = useLocalStorage<boolean>({
    key: 'socket-ticket',
    defaultValue: false,
  });
  const branches = useBranches();
  const { user } = useAuthContext();
  const { mutateAsync } = useSelectBranch();

  const handleChange = (event: any) => {
    mutateAsync(event.target.value);
  };
  const printerRole = useMemo(() => {
    const roles = [Roles.ATM, Roles.ADMIN, Roles.SUPER_ADMIN, Roles.OWNER_SOFT];
    const rol = user?.role?.id;
    return roles.includes(rol ?? 0);
  }, [user]);
  let printerRender: JSX.Element[] = [];
  if (printerRole) {
    printerRender = [
      <DropdownItem closeOnSelect={false} isReadOnly key="flagSocketCommander">
        <Checkbox
          color="primary"
          isSelected={flagSocketCommander}
          onValueChange={setFlagSocketCommander}
        >
          Impresion de Comanda
        </Checkbox>
      </DropdownItem>,
      <DropdownItem closeOnSelect={false} isReadOnly key="flagSocketTicket">
        <Checkbox color="primary" isSelected={flagSocketTicket} onValueChange={setFlagSocketTicket}>
          Impresion de Factura
        </Checkbox>
      </DropdownItem>,
    ];
  }
  return (
    <Dropdown closeOnSelect={false} isDismissable={false}>
        <DropdownTrigger>
          <Button disableRipple isIconOnly radius="full" variant="light" className="p-0 ">
            <Icon className="text-default-500" icon="solar:settings-linear" width={20} />
          </Button>
        </DropdownTrigger>
      <DropdownMenu  closeOnSelect={false}>
        <DropdownItem isReadOnly>
          <Select
          label="Sucursal"
            value={user?.branchSelected?.id}
            selectedKeys={user?.branchSelected?.id ? [user?.branchSelected?.id] : []}
            onChange={handleChange}
          >
            {branches?.map((branch) => (
              <SelectItem key={branch.id} value={branch.id}>
                {branch.name}
              </SelectItem>
            ))}
          </Select>
        </DropdownItem>
        <DropdownItem isReadOnly>
        <TypeCreateOrder />
        </DropdownItem>
        {printerRender as any}
      </DropdownMenu>
    </Dropdown>
  );
};
